import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatInputModule} from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {RatingSelectorComponent} from './rating-selector.component';

@NgModule({
    exports: [RatingSelectorComponent],
    declarations: [RatingSelectorComponent],
    imports: [CommonModule, MatCheckboxModule, MatInputModule]
})
export class RatingSelectorModule {
}